import { api } from './api';
import { setupLogo } from './logo';

// Оформление страницы входа — по последнему выбранному шаблону на этом компьютере
try {
  const t = (localStorage.getItem('hr-theme') || 'B').toLowerCase();
  if (['a', 'b', 'c', 'd'].includes(t)) document.body.classList.add(`theme-${t}`);
} catch { /* localStorage недоступен */ }

// Название, логотип и контакт администратора — из «Администрирование → Общие»
api<any>('GET', '/public-info').then(info => {
  const brand = document.getElementById('brand')!;
  const name = info.org_name || 'HR · Реестр';
  if (info.org_name) document.title = `Вход · ${info.org_name}`;
  const mode = info.has_logo ? info.brand_mode || 'both' : 'name';
  brand.textContent = '';
  brand.className = `logo login-logo brand-${mode}`;
  if (mode !== 'name') {
    const wrap = document.createElement('span'); wrap.className = 'logo-mark';
    const img = document.createElement('img'); img.src = `/api/public/logo?v=${Date.now()}`; img.alt = name; img.className = 'logo-img';
    wrap.append(img); brand.append(wrap);
    setupLogo(wrap, img, info.logo_bg || 'auto');
  }
  if (mode !== 'logo') { const t = document.createElement('span'); t.className = 'logo-name'; t.textContent = name; brand.append(t); }
  if (info.admin_contact) document.getElementById('contact')!.textContent = `Нет доступа или забыли пароль? Администратор: ${info.admin_contact}`;
}).catch(() => { /* не критично */ });

const form = document.getElementById('login-form') as HTMLFormElement;
const err = document.getElementById('login-error') as HTMLElement;
const btn = form.querySelector('button') as HTMLButtonElement;

form.addEventListener('submit', async e => {
  e.preventDefault();
  err.textContent = '';
  btn.disabled = true;
  const fd = new FormData(form);
  try {
    await api('POST', '/login', { login: fd.get('login'), password: fd.get('password') });
    location.href = '/';
  } catch (ex: any) {
    err.textContent = ex.message;
    btn.disabled = false;
  }
});
